import type { CreateChatThread200AllOf } from './createChatThread200AllOf';
import type { CreateChatThread200AllOfFive } from './createChatThread200AllOfFive';

export type CreateChatThread200 = CreateChatThread200AllOf & CreateChatThread200AllOfFive;
